export default {
  documentos: [],
  filtros: {
    perPage: 20,
    page: 1,
    periodo: [],
    campoData: [],
    termo: '',
    referenciaInterna: '',
    referenciaCliente: '',
    documento: '',
    tipoArquivo: '',
    extensao: '',
    dataCadastro: '',
    dataCadastroCondicao: '',
    order: 'dataCadastro',
    direcao: '',
  },
  campos: {
    referenciaInterna: 'processo.pri_esp_refcliente',
    referenciaCliente: 'processo.pri_esp_referencia',
    documento: 'arquivo.dcm_des_descricao',
    tipoArquivo: 'arquivo.tipo_arquivo',
    extensao: 'arquivo.extensao',
    dataCadastro: '"dataCadastro"',
  },
  colDefault: 'dataCadastro',
  directionDefault: '',
  filterDefs: {
    referenciaInterna: {
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        moduleFiltros: 'ged',
        fetch: 'fetchAllArquivosProcessos',
        colDef: {
          field: 'referenciaInterna',
        },
      },
    },
    referenciaCliente: {
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        moduleFiltros: 'ged',
        fetch: 'fetchAllArquivosProcessos',
        colDef: {
          field: 'referenciaCliente',
        },
      },
    },
    documento: {
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        moduleFiltros: 'ged',
        fetch: 'fetchAllArquivosProcessos',
        colDef: {
          field: 'documento',
        },
      },
    },
    tipoArquivo: {
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        moduleFiltros: 'ged',
        fetch: 'fetchAllArquivosProcessos',
        colDef: {
          field: 'tipoArquivo',
        },
      },
    },
    extensao: {
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        moduleFiltros: 'ged',
        fetch: 'fetchAllArquivosProcessos',
        colDef: {
          field: 'extensao',
        },
      },
    },
    dataCadastro: {
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        moduleFiltros: 'ged',
        fetch: 'fetchAllArquivosProcessos',
        colDef: {
          field: 'dataCadastro',
        },
      },
    },
  },
  // Sortable false para desabilitar o sort local do vuetify
  tableColumns: [
    {
      text: 'referenciaCliente',
      value: 'referenciaInterna',
      sortable: false,
      filterable: true,
    },
    {
      text: 'referenciaTrust',
      value: 'referenciaCliente',
      sortable: false,
      filterable: true,
    },
    {
      text: 'Documento',
      value: 'documento',
      sortable: false,
      filterable: true,
    },
    {
      text: 'Tipo',
      value: 'tipoArquivo',
      sortable: false,
      filterable: true,
    },
    {
      text: 'Extensão',
      value: 'extensao',
      sortable: false,
      filterable: true,
    },
    {
      text: 'Data',
      value: 'dataCadastro',
      sortable: false,
      filterable: true,
    },
    {
      text: 'Ações',
      value: 'actions',
      sortable: false,
      serverSortable: false,
      filterable: false,
    },
  ],
};
